import getClassNameFactory from "@wel-ui/utility-class-names";

const getSolutionFinderClassName = getClassNameFactory("CecTrtaSolutionFinder");
const getSolutionBreadcrumbClassName = getClassNameFactory(
  "CecTrtaSolutionBreadcrumb"
);

export const getBundlePath = () => {
  return document
    .querySelector(
      `.${getSolutionFinderClassName()}, .${getSolutionBreadcrumbClassName()}`
    )
    .getAttribute("data-base-url");
};



// WEBPACK FOOTER //
// ./js/helpers/cec.js